export const comments_3281822 = {"data":{"data":[],"links":{}}}